import { CashFaviconAttributes, ThemeType } from '../../types'

export enum FaviconAsset {
  AppleTouchIcon = 'appleTouchIcon',
  Manifest = 'manifest',
  Ico = 'ico',
  Svg = 'svg',
}

const BASE_CDN_URL = 'https://cash-f.squarecdn.com'

const FAVICON_ASSETS_DEFAULTS: Record<ThemeType, Record<FaviconAsset, CashFaviconAttributes>> = {
  default: {
    [FaviconAsset.AppleTouchIcon]: {
      rel: 'apple-touch-icon',
      href: `${BASE_CDN_URL}/static/apple-touch-icon.png`,
      integrity: 'sha384-obbtLXUmL5CCcijDtMgdqvtSyKu3FTcGYIdVn6uif5nIxTaS7u3IMUG3Wl1PjBox',
    },
    [FaviconAsset.Manifest]: {
      rel: 'manifest',
      href: `${BASE_CDN_URL}/static/manifest.webmanifest`,
      integrity: 'sha384-CdK6MPtohWsnTcqD6CGLRmq1Wc5Al3/3LP9FNcnsODQKI3SMTfCiCamhNianUQCU',
    },
    [FaviconAsset.Ico]: {
      rel: 'icon',
      href: `${BASE_CDN_URL}/static/favicon.ico`,
      integrity: 'sha384-4ChiDA321IPrHSobMPeW1n8RX2GU6pY6iWH7h79DqAFaYyhrlbYTvRWEAJqMZ3GS',
      sizes: '16x16,32x32',
      type: 'image/x-icon',
    },
    [FaviconAsset.Svg]: {
      rel: 'icon',
      href: `${BASE_CDN_URL}/static/favicon.svg`,
      integrity: 'sha384-KFrrYlHN2FMoPYRtljOsgHAreGaHwX+UtbQgfY3LbnCzenjycuPRU7zBKWf7yaQZ',
      sizes: 'any',
      type: 'image/svg+xml',
    },
  },
  taxes: {
    [FaviconAsset.AppleTouchIcon]: {
      rel: 'apple-touch-icon',
      href: `${BASE_CDN_URL}/static/taxes/monochrome/apple-touch-icon.png`,
      integrity: 'sha384-1VMsB8h88YxdiJFY1YzqGSnXgHs/BZD35G1AtooAVwH5N4Vkc2VMKH4uL8tbfzGo',
    },
    [FaviconAsset.Manifest]: {
      rel: 'manifest',
      href: `${BASE_CDN_URL}/static/taxes/monochrome/manifest.webmanifest`,
      integrity: 'sha384-p1nA3DlkNCMgktuw+GSuWceNoCGKFavFKPCr/A6dAWkhnw4pwgZjjXV8OAjj395j',
    },
    [FaviconAsset.Ico]: {
      rel: 'icon',
      href: `${BASE_CDN_URL}/static/taxes/monochrome/favicon.ico`,
      integrity: 'sha384-AshGOA0y03sOBcf8L/QLhfT5JQ3LKxnrUIBaXP+eKeK56L1ycxrULiNblesaIc/n',
      sizes: '16x16,32x32',
      type: 'image/x-icon',
    },
    [FaviconAsset.Svg]: {
      rel: 'icon',
      href: `${BASE_CDN_URL}/static/taxes/monochrome/favicon.svg`,
      integrity: 'sha384-7dhEq1EvcFPveRFTSfwSEJ0dcLYrn/IgQkKes6gaSlD0wnqAC6WCekE8LmrVSTC2',
      sizes: 'any',
      type: 'image/svg+xml',
    },
  },
}

export const getAssetDefaults = (asset: FaviconAsset, theme: ThemeType = 'default') => {
  return FAVICON_ASSETS_DEFAULTS[theme][asset] as CashFaviconAttributes
}

export const setDynamicFavicon = ({
  attributes,
  query,
}: {
  attributes: Partial<CashFaviconAttributes>
  query?: string
}) => {
  const linkEl = query ? document.querySelector(query) : document.createElement('link')

  if (!linkEl) return

  Object.entries(attributes).forEach(([key, value]) => {
    linkEl.setAttribute(key, value)
  })

  const head = document.querySelector('head')
  !query && head?.appendChild(linkEl)
}
